"use client";

import { preload } from "react-dom";

/** The decorative desktop background; see app/globals.css `body` rules. */
export const DESKTOP_BACKGROUND_SRC = "/static/sticko-website-background-new.svg";
/** The same media query globals.css gates the background-image on. */
export const DESKTOP_BACKGROUND_MEDIA = "(min-width: 900px)";

/**
 * Preloads the 118KB desktop background SVG from HTML-parse time.
 *
 * It is referenced from globals.css as a CSS background-image, which the
 * browser's preload scanner cannot see, so without this its fetch only starts
 * after the CSS parses and <body> paints — and then it repaints the whole
 * viewport late, which is what pushed Speed Index to 2.1s while FCP and LCP
 * stayed sub-second.
 *
 * `react-dom`'s preload() rather than a JSX <link rel="preload">: React 19
 * registers a JSX preload with its resource system AND renders the element, so
 * the JSX form was emitted twice in every document (~110 bytes on each of the
 * ~25k pages). preload() emits exactly one tag. The `media` option is what
 * makes it usable here — it gates the hint to the same >=900px query as the CSS
 * rule, so phones never download a desktop-only asset. (An earlier comment
 * claimed preload() had no `media` option; the installed react-dom supports it
 * on every render path, and the emitted HTML is verified by
 * tests/rendering-invariants.test.ts.)
 *
 * No fetchPriority: the default (low) image priority keeps it from competing
 * with the LCP cover image for bandwidth.
 *
 * A Client Component because Next's docs only promise these methods there; it
 * still renders on the server, and the hint lands in the streamed <head>.
 */
export function PreloadDesktopBackground() {
  preload(DESKTOP_BACKGROUND_SRC, { as: "image", media: DESKTOP_BACKGROUND_MEDIA });
  return null;
}
